import React from "react";
import { Box, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { resetNodesState, updateAddNodes, updateAddLinks } from "../../../redux/features/nodes";

const RADIUS = 65;

type Preset = {
  label: string;
  rooms: {
    label: string;
    roomtype: string;
    width: { min: number; max: number };
    height: { min: number; max: number };
    ratio: { min: number; max: number };
  }[];
  links: {
    source: number;
    target: number;
    color: string;
  }[];
};

const allSections = [
  {
    sectionLabel: "1 BHK",
    presets: [
      {
        label: "1 BHK",
        rooms: [
          { label: "living", roomtype: "Living Room", width: { min: 8, max: 11 }, height: { min: 8, max: 11 }, ratio: { min: 1, max: 2 } },
          { label: "bed", roomtype: "Bedroom", width: { min: 11, max: 11 }, height: { min: 11, max: 11 }, ratio: { min: 1, max: 2 } },
          { label: "bath", roomtype: "Bathroom", width: { min: 6, max: 6 }, height: { min: 4, max: 4 }, ratio: { min: 1, max: 2 } },
          { label: "wc", roomtype: "Bathroom", width: { min: 3, max: 3 }, height: { min: 4, max: 4 }, ratio: { min: 1, max: 2 } },
          { label: "kitchen", roomtype: "Kitchen", width: { min: 8, max: 8 }, height: { min: 5, max: 5 }, ratio: { min: 1, max: 2 } },
        ],
        links: [
          { source: 0, target: 1, color: "#FF9A56" },
          { source: 0, target: 4, color: "#FF9A56" },
          { source: 0, target: 2, color: "#FF9A56" },
          { source: 1, target: 4, color: "#FF9A56" },
          { source: 2, target: 3, color: "#FF9A56" },
          { source: 1, target: 3, color: "#aaaaaa" },
        ],
      },
    ],
  },
  {
    sectionLabel: "2 BHK",
    presets: [
      {
        label: "2 BHK Standard",
        rooms: [
          { label: "living", roomtype: "Living Room", width: { min: 7, max: 11 }, height: { min: 7, max: 11 }, ratio: { min: 1, max: 2 } },
          { label: "bed", roomtype: "Bedroom", width: { min: 10, max: 13 }, height: { min: 10, max: 13 }, ratio: { min: 1, max: 2 } },
          { label: "bed1", roomtype: "Bedroom", width: { min: 13, max: 13 }, height: { min: 9, max: 9 }, ratio: { min: 1, max: 2 } },
          { label: "bath", roomtype: "Bathroom", width: { min: 4, max: 4 }, height: { min: 5, max: 5 }, ratio: { min: 1, max: 2 } },
          { label: "wc", roomtype: "Bathroom", width: { min: 3, max: 3 }, height: { min: 5, max: 5 }, ratio: { min: 1, max: 2 } },
          { label: "kitchen", roomtype: "Kitchen", width: { min: 7, max: 7 }, height: { min: 5, max: 5 }, ratio: { min: 1, max: 2 } },
        ],
        links: [
          { source: 0, target: 1, color: "#FF9A56" },
          { source: 0, target: 2, color: "#FF9A56" },
          { source: 0, target: 5, color: "#FF9A56" },
          { source: 1, target: 2, color: "#FF9A56" },
          { source: 1, target: 5, color: "#FF9A56" },
          { source: 1, target: 3, color: "#FF9A56" },
          { source: 1, target: 4, color: "#FF9A56" },
          { source: 2, target: 3, color: "#FF9A56" },
          { source: 2, target: 4, color: "#aaaaaa" },
          { source: 5, target: 4, color: "#aaaaaa" },
        ],
      },
      {
        label: "2 BHK With Store",
        rooms: [
          { label: "dining", roomtype: "Dining Room", width: { min: 8, max: 8 }, height: { min: 12, max: 12 }, ratio: { min: 1, max: 2 } },
          { label: "bed", roomtype: "Bedroom", width: { min: 13, max: 13 }, height: { min: 10, max: 10 }, ratio: { min: 1, max: 2 } },
          { label: "bath", roomtype: "Bathroom", width: { min: 5, max: 5 }, height: { min: 7, max: 7 }, ratio: { min: 1, max: 2 } },
          { label: "bed1", roomtype: "Bedroom", width: { min: 12, max: 12 }, height: { min: 15, max: 15 }, ratio: { min: 1, max: 2 } },
          { label: "bath1", roomtype: "Bathroom", width: { min: 5, max: 5 }, height: { min: 7, max: 7 }, ratio: { min: 1, max: 2 } },
          { label: "living", roomtype: "Living Room", width: { min: 13, max: 13 }, height: { min: 10, max: 10 }, ratio: { min: 1, max: 2 } },
          { label: "kitchen", roomtype: "Kitchen", width: { min: 8, max: 8 }, height: { min: 10, max: 10 }, ratio: { min: 1, max: 2 } },
          { label: "store", roomtype: "Others", width: { min: 6, max: 6 }, height: { min: 12, max: 12 }, ratio: { min: 1, max: 2 } },
        ],
        links: [
          { source: 0, target: 1, color: "#FF9A56" },
          { source: 0, target: 3, color: "#FF9A56" },
          { source: 0, target: 5, color: "#FF9A56" },
          { source: 0, target: 6, color: "#FF9A56" },
          { source: 0, target: 7, color: "#FF9A56" },
          { source: 1, target: 2, color: "#FF9A56" },
          { source: 1, target: 3, color: "#FF9A56" },
          { source: 3, target: 4, color: "#FF9A56" },
          { source: 5, target: 6, color: "#FF9A56" },
          { source: 5, target: 7, color: "#FF9A56" },
        ],
      },
      {
        label: "2 BHK Compact",
        rooms: [
          { label: "dining", roomtype: "Dining Room", width: { min: 8, max: 8 }, height: { min: 12, max: 12 }, ratio: { min: 1, max: 2 } },
          { label: "bed", roomtype: "Bedroom", width: { min: 13, max: 13 }, height: { min: 10, max: 10 }, ratio: { min: 1, max: 2 } },
          { label: "bath", roomtype: "Bathroom", width: { min: 5, max: 5 }, height: { min: 7, max: 7 }, ratio: { min: 1, max: 2 } },
          { label: "bed1", roomtype: "Bedroom", width: { min: 12, max: 12 }, height: { min: 15, max: 15 }, ratio: { min: 1, max: 2 } },
          { label: "bath1", roomtype: "Bathroom", width: { min: 5, max: 5 }, height: { min: 7, max: 7 }, ratio: { min: 1, max: 2 } },
          { label: "living", roomtype: "Living Room", width: { min: 12, max: 12 }, height: { min: 10, max: 10 }, ratio: { min: 1, max: 2 } },
          { label: "kitchen", roomtype: "Kitchen", width: { min: 8, max: 8 }, height: { min: 10, max: 10 }, ratio: { min: 1, max: 2 } },
        ],
        links: [
          { source: 0, target: 1, color: "#FF9A56" },
          { source: 0, target: 3, color: "#FF9A56" },
          { source: 0, target: 5, color: "#FF9A56" },
          { source: 0, target: 6, color: "#FF9A56" },
          { source: 1, target: 2, color: "#FF9A56" },
          { source: 1, target: 3, color: "#FF9A56" },
          { source: 3, target: 4, color: "#FF9A56" },
          { source: 5, target: 6, color: "#FF9A56" },
        ],
      },
    ],
  },
  {
    sectionLabel: "3 BHK",
    presets: [
      {
        label: "3 BHK",
        rooms: [
          { label: "dining", roomtype: "Dining Room", width: { min: 8, max: 8 }, height: { min: 12, max: 12 }, ratio: { min: 1, max: 2 } },
          { label: "bed", roomtype: "Bedroom", width: { min: 13, max: 13 }, height: { min: 10, max: 10 }, ratio: { min: 1, max: 2 } },
          { label: "bath", roomtype: "Bathroom", width: { min: 5, max: 5 }, height: { min: 7, max: 7 }, ratio: { min: 1, max: 2 } },
          { label: "bed1", roomtype: "Bedroom", width: { min: 12, max: 12 }, height: { min: 15, max: 15 }, ratio: { min: 1, max: 2 } },
          { label: "bath1", roomtype: "Bathroom", width: { min: 5, max: 5 }, height: { min: 7, max: 7 }, ratio: { min: 1, max: 2 } },
          { label: "living", roomtype: "Living Room", width: { min: 12, max: 12 }, height: { min: 10, max: 10 }, ratio: { min: 1, max: 2 } },
          { label: "kitchen", roomtype: "Kitchen", width: { min: 8, max: 8 }, height: { min: 10, max: 10 }, ratio: { min: 1, max: 2 } },
          { label: "bed2", roomtype: "Bedroom", width: { min: 9, max: 9 }, height: { min: 12, max: 12 }, ratio: { min: 1, max: 2 } },
          { label: "wc", roomtype: "Bathroom", width: { min: 5, max: 5 }, height: { min: 3, max: 3 }, ratio: { min: 1, max: 2 } },
        ],
        links: [
          { source: 0, target: 1, color: "#FF9A56" },
          { source: 0, target: 3, color: "#FF9A56" },
          { source: 0, target: 5, color: "#FF9A56" },
          { source: 0, target: 6, color: "#FF9A56" },
          { source: 0, target: 7, color: "#FF9A56" },
          { source: 1, target: 2, color: "#FF9A56" },
          { source: 1, target: 3, color: "#FF9A56" },
          { source: 3, target: 4, color: "#FF9A56" },
          { source: 5, target: 6, color: "#FF9A56" },
          { source: 5, target: 7, color: "#FF9A56" },
          { source: 7, target: 8, color: "#FF9A56" },
        ],
      },
    ],
  },
];

const MiniGraphCard = ({ preset, onClick }: { preset: Preset; onClick: () => void }) => {
  const nodeCount = preset.rooms.length;
  const cardWidth = 180;
  const cardHeight = 120;
  const cx = cardWidth / 2;
  const cy = cardHeight / 2;
  const r = 35;
  const nodeR = 18;

  const positions = preset.rooms.map((_, i) => ({
    x: cx + r * Math.cos((2 * Math.PI * i) / nodeCount - Math.PI / 2),
    y: cy + r * Math.sin((2 * Math.PI * i) / nodeCount - Math.PI / 2),
  }));

  const getColor = (roomtype: string) => {
    switch (roomtype.toLowerCase()) {
      case "living room": return "#4CAF50";
      case "bedroom": return "#2196F3";
      case "kitchen": return "#FF9800";
      case "bathroom": return "#9C27B0";
      default: return "#FF9A56";
    }
  };

  return (
    <Box
      onClick={onClick}
      sx={{
        width: `${cardWidth}px`,
        backgroundColor: "white",
        borderRadius: "12px",
        border: "2px solid #1a1a1a",
        cursor: "pointer",
        padding: "8px",
        transition: "all 0.1s ease",
        "&:hover": {
          transform: "translate(-2px, -2px)",
          backgroundColor: "#fffdfa",
        },
        "&:active": {
          transform: "translate(1px, 1px)",
        },
      }}
    >
      <svg width={cardWidth - 16} height={cardHeight} style={{ display: "block" }}>
        {preset.links.map((link, i) => (
  <line
    key={i}
    x1={positions[link.source].x}
    y1={positions[link.source].y}
    x2={positions[link.target].x}
    y2={positions[link.target].y}
    stroke={link.color}
    strokeWidth={1.5}
    strokeDasharray={link.color === "#aaaaaa" ? "4,2" : "none"}
  />
))}
        {preset.rooms.map((room, i) => (
          <g key={i}>
            <circle
              cx={positions[i].x}
              cy={positions[i].y}
              r={nodeR}
              fill={getColor(room.roomtype)}
              opacity={0.9}
            />
            <text
              x={positions[i].x}
              y={positions[i].y}
              textAnchor="middle"
              dominantBaseline="middle"
              fill={room.roomtype.toLowerCase() === "bathroom" ? "#1a1a1a" : "#FBE5C6"}
              fontSize="8"
              fontFamily="Poppins"
              fontWeight="700"
            >
              {room.roomtype.split(" ")[0]}
            </text>
          </g>
        ))}
      </svg>

      <Typography
        sx={{
          fontFamily: "Poppins",
          fontSize: "11px",
          fontWeight: 700,
          color: "#1a1a1a",
          textAlign: "center",
          mt: "6px",
        }}
      >
        {preset.label}
      </Typography>
    </Box>
  );
};

const BHKPresetStrip = () => {
  const dispatch = useDispatch<AppDispatch>();
  const nodes = useSelector((state: RootState) => state.nodesState.nodes);

  const handleSelectPreset = (preset: Preset) => {
    dispatch(resetNodesState());

    const width = visualViewport?.width ?? 1200;
    const height = visualViewport?.height ?? 800;
    const stripHeight = 180; 
    const positions: { x: number; y: number }[] = [];
    const minDistance = 2 * RADIUS;

    preset.rooms.forEach((room, index) => {
      let x = 0;
      let y = 0;
      let attempts = 0;

      do {
        x = width * 0.25 + Math.random() * (width * 0.5);
        y = height * 0.1 + Math.random() * ((height - stripHeight) * 0.75);
        attempts++;
        const overlaps = positions.some(
          (pos) => Math.sqrt((pos.x - x) ** 2 + (pos.y - y) ** 2) < minDistance
        );
        if (!overlaps) break;
      } while (attempts < 200);

      positions.push({ x, y });

      dispatch(
        updateAddNodes({
          id: index,
          label: room.label,
          roomtype: room.roomtype,
          x,
          y,
          color: "#FF9A56",
          width: room.width,
          height: room.height,
          ratio: room.ratio,
        })
      );
    });

    preset.links.forEach((link) => {
      dispatch(updateAddLinks(link));
    });
  };

  return (
    <Box
    data-tour="bhk-presets"
      sx={{
        position: "fixed",
        bottom: 12,
        left: "21.5vw",
        right: "26vw",
        backgroundColor: "#FBE5C6",
        border: "2px solid #1a1a1a",
        borderRadius: "16px",
        padding: "16px 20px",
        display: "flex",
        flexDirection: "column",
        gap: 2,
        zIndex: 1000,
        overflowX: "auto",
      }}
    >
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontSize: "12px",
          fontWeight: 600,
          color: "#FF9A56",
        }}
      >
        Presets — click to load
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "row", gap: 3, alignItems: "flex-start" }}>
        {allSections.map((section, si) => (
          <Box key={si} sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            <Typography
              sx={{
                fontFamily: "Poppins",
                fontSize: "10px",
                fontWeight: 700,
                color: "#1a1a1a",
                textAlign: "center",
                borderBottom: "2px solid #1a1a1a",
                pb: "4px",
                mb: "8px",
              }}
            >
              {section.sectionLabel}
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
              {section.presets.map((preset, i) => (
                <MiniGraphCard
                  key={i}
                  preset={preset}
                  onClick={() => handleSelectPreset(preset)}
                />
              ))}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default BHKPresetStrip;